import i18n from '@/lang/i18n';
const COMMON_TABLE_CLASS = "border-sm border-opacity-50 text-center text-grey-darken-3"
const CHART_DETAIL_TABLE_CLASS = "border-surface border-opacity-100 border-md text-center bg-grey-lighten-1 text-grey-darken-3";
const CHART_COMMON_CLASS = "mx-auto d-flex mb-6";

export const EVERY_24_HOUR_REPORT_PREVIEW_TYPE = "App\\Services\\OutputReports\\Every24hours\\PreviewCreateService";
export const EVERY_24_HOUR_REPORT_TYPE = "App\\Services\\OutputReports\\Every24hours\\PdfCreateService";

export const TITLE_HEADERS = [
  {
    isTitle: true,
    keyName: "",
    labelPath: "pages.every24HoursReport.preview.title",
    class: "col-6 border-sm border-opacity-100 text-center bg-grey-darken-3 font-weight-bold"
  },
  {
    isTitle: false,
    keyName: "",
    labelPath: "pages.every24HoursReport.preview.driverName",
    class: `${COMMON_TABLE_CLASS} col-1 font-weight-bold`
  },
  {
    isTitle: false,
    keyName: "driver_name",
    labelPath: "",
    class: `${COMMON_TABLE_CLASS} col-2`
  },
  {
    isTitle: false,
    keyName: "",
    labelPath: "pages.every24HoursReport.preview.carNumber",
    class: `${COMMON_TABLE_CLASS} col-1 font-weight-bold`
  },
  {
    isTitle: false,
    keyName: "car_number",
    labelPath: "",
    class: `${COMMON_TABLE_CLASS} col-2`
  },
];

export const DRIVING_DETAIL_HEADERS = [
  {
    isTitle: false,
    keyName: "",
    labelPath: 'pages.every24HoursReport.preview.leavingWarehouse',
    class: `${COMMON_TABLE_CLASS} col-2  font-weight-bold`,
  },
  {
    isTitle: false,
    keyName: "",
    labelPath: 'pages.every24HoursReport.preview.returningWarehouse',
    class: `${COMMON_TABLE_CLASS} col-2  font-weight-bold`,
  },
  {
    isTitle: false,
    keyName: "",
    labelPath: 'pages.every24HoursReport.preview.totalOperationTime',
    class: `${COMMON_TABLE_CLASS} col-1  font-weight-bold`,
  },
  {
    isTitle: false,
    keyName: "",
    labelPath: 'pages.every24HoursReport.preview.totalMileage',
    class: `${COMMON_TABLE_CLASS} col-2  font-weight-bold`,
  },
  {
    isTitle: false,
    keyName: "",
    labelPath: 'pages.every24HoursReport.preview.drivingTime',
    class: `${COMMON_TABLE_CLASS} col-1  font-weight-bold`,
  },
  {
    isTitle: false,
    keyName: "",
    labelPath: 'pages.every24HoursReport.preview.maxContinuousDrivingTime',
    class: `${COMMON_TABLE_CLASS} col-2  font-weight-bold`,
  },
  {
    isTitle: false,
    keyName: "",
    labelPath: 'pages.every24HoursReport.preview.maximumSpeed',
    class: `${COMMON_TABLE_CLASS} col-2  font-weight-bold`,
  },
];

export const DRIVING_DETAIL_ROWS = [
  {
    id: "start-time-",
    dataName: "data-start-time",
    dataKey: "leaving_warehouse",
    class: COMMON_TABLE_CLASS,
    isConvertToJson: false
  },
  {
    id: "end-time-",
    dataName: "data-end-time",
    dataKey: "returning_warehouse",
    class: COMMON_TABLE_CLASS,
    isConvertToJson: false
  },
  {
    id: "",
    dataName: "",
    dataKey: "total_operation_time",
    class: COMMON_TABLE_CLASS,
    isConvertToJson: false
  },
  {
    id: "",
    dataName: "d",
    dataKey: "total_mileage",
    class: COMMON_TABLE_CLASS,
    isConvertToJson: false
  },
  {
    id: "",
    dataName: "",
    dataKey: "total_driving_time",
    class: COMMON_TABLE_CLASS,
    isConvertToJson: false
  },
  {
    id: "",
    dataName: "",
    dataKey: "max_continuous_driving_time",
    class: COMMON_TABLE_CLASS,
    isConvertToJson: false
  },
  {
    id: "",
    dataName: "",
    dataKey: "maximum_speed",
    class: COMMON_TABLE_CLASS,
    isConvertToJson: false
  },
];

export const DEFAULT_OUTPUT_TIME = "24h";
export const OUTPUT_TIME_LIST = {
  "four-minute": {
    label: i18n.global.t('pages.every24HoursReport.outputTimeList.fourMinutes'),
    value: "4min"
  },
  "twelve-minute": {
    label: i18n.global.t('pages.every24HoursReport.outputTimeList.twelveMinutes'),
    value: "12min"
  },
  "eight-hour": {
    label: i18n.global.t('pages.every24HoursReport.outputTimeList.eigntHours'),
    value: "8h"
  },
  "twenty-four-hours": {
    label: i18n.global.t('pages.every24HoursReport.outputTimeList.twentyFourHours'),
    value: DEFAULT_OUTPUT_TIME
  }
};

export const CHART_DETAIL_TABLE_HEADERS = [
  {
    isTitle: false,
    keyName: "",
    labelPath: 'pages.every24HoursReport.preview.deliveryDate',
    class: `${CHART_DETAIL_TABLE_CLASS} font-weight-bold`,
  },
  {
    isTitle: false,
    keyName: "",
    labelPath: 'pages.every24HoursReport.preview.deliveryStartTime',
    class: `${CHART_DETAIL_TABLE_CLASS} font-weight-bold`,
  },
  {
    isTitle: false,
    keyName: "",
    labelPath: 'pages.every24HoursReport.preview.totalMileage',
    class: `${CHART_DETAIL_TABLE_CLASS} font-weight-bold`,
  },
  {
    isTitle: false,
    keyName: "",
    labelPath: 'pages.every24HoursReport.preview.drivingTime',
    class: `${CHART_DETAIL_TABLE_CLASS} font-weight-bold`,
  },
];

export const CHART_DETAIL_TABLE_ROWS = [
  {
    id: "date-at-output-time-",
    dataName: "",
    dataKey: "deliveryPlanDate",
    class: CHART_DETAIL_TABLE_CLASS,
    isConvertToJson: false
  },
  {
    id: "start-time-at-output-time-",
    dataName: "",
    dataKey: "displayStartTime",
    class: CHART_DETAIL_TABLE_CLASS,
    isConvertToJson: false
  },
  {
    id: "distance-at-output-time-",
    dataName: "",
    dataKey: "drivingDistance",
    class: CHART_DETAIL_TABLE_CLASS,
    isConvertToJson: false
  },
  {
    id: "driving-time-at-output-time-",
    dataName: "data-driving-times",
    dataKey: "drivingTime",
    class: CHART_DETAIL_TABLE_CLASS,
    isConvertToJson: true
  },
]

export const X_LABEL_MINUTE_INTERVAL: {[key: string]: number} = {
  '24h': 360,
  '8h': 120,
  '12min': 3,
  '4min': 1
};

export const X_AXIS_STEP_SIZE: {[key: string]: number} = {
  '24h': 3600000,
  '8h': 1800000,
  '12min': 30000,
  '4min': 15000
};

export const X_AXIS_DIVISIONS = 4;

export const SLIDE_BAR_STEP_SECONDS: {[key: string]: number} = {
  '24h': 864,
  '8h': 288,
  '12min': 7.2,
  '4min': 24
};

export const SPEED_OPTIONS = {
  grid: {
    left: 50,
    top: 11,
    bottom: 5,
    width: '97%',
    height: '88%',
  },
  yAxis: {
    min: 0,
    max: 140,
    interval: 20,
  }
}

export const SPEED_CHART_LABELS = [
  "pages.every24HoursReport.preview.speed",
  "pages.every24HoursReport.preview.speedUnit"
]

export const DISTANCE_OPTIONS = {
  grid: {
    left: 50,
    top: 10,
    bottom: 5,
    width: '97%',
    height: '85%',
  },
  yAxis: {
    min: 0,
    max: 160,
    interval: 20,
  }
}

export const DISTANCE_CHART_LABELS = [
  "pages.every24HoursReport.preview.distance",
  "pages.every24HoursReport.preview.distanceUnit"
]

export const ROTATION_SPEED_OPTIONS = {
  grid: {
    left: 50,
    top: 13,
    bottom: 5,
    width: '97%',
    height: '85%',
  },
  yAxis: {
    min: 0,
    max: 4000,
    interval: 2000,
  }
}

export const ROTATION_SPEED_CHART_LABELS = [
  "pages.every24HoursReport.preview.rotationSpeed",
  "pages.every24HoursReport.preview.rotationSpeedUnit"
]

export const MARKER_SIZE = 15;
export const DEFAULT_DRIVING_DISTANCE = 'N/A';
export const DEFAULT_DRIVING_TIME = '00:00:00';
